export const isScrolledIntoView = (elem, offset) => {
    let docViewTop = $(window).scrollTop();
    let docViewBottom = docViewTop + $(window).height();

    let elemTop = $(elem).offset().top + offset;
    let elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(".js-play-video").click(function () {
    let $this = $(this)

    let $nearestVideo = $this.siblings('video')

    if ($nearestVideo.length > 0) {
        $nearestVideo[0].play()
        $this.addClass('hidden')
    }
});
